/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/Model';

/**
 * A model that represents a Banner
 * @extends {Model}
 */
export default class Banner extends Model {
	/**
	 * @method id
	 * @returns {number}
	 */
	id = Model.attribute('id');
	/**
	 * @method props
	 * @returns {object}
	 */
	props = Model.attribute('props');
	/**
	 * @method hasStarted
	 * @returns {boolean}
	 */
	hasStarted = Model.attribute('hasStarted');
	/**
	 * @method hasEnded
	 * @returns {boolean}
	 */
	hasEnded = Model.attribute('hasEnded');

	__getProp(key) {
		return (this.props() || {})[key] || {};
	}

	/**
	 * @returns {object}
	 */
	setup() {
		return this.__getProp('setup');
	}
	/**
	 * @returns {object}
	 */
	content() {
		return this.__getProp('content');
	}
	/**
	 * @returns {object}
	 */
	visual() {
		return this.__getProp('visual');
	}
	/**
	 * @returns {object}
	 */
	link() {
		return this.__getProp('link');
	}
	/**
	 * @returns {object}
	 */
	ga() {
		return this.__getProp('ga');
	}
}
